import { Component, OnInit, Renderer, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { ROUTES } from '../../sidebar/sidebar.component';
import { Router, ActivatedRoute } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { AuthService } from 'services/auth/auth.service';
import { environment } from '../../../environments/environment';
import { UserIdleService } from 'services/user-idle/user-idle.service';
import { UserInfoService } from 'services/user-info/user-info.service';
import { Subscription } from 'rxjs';

declare var $: any;

@Component({
	moduleId: module.id,
	selector: 'navbar-cmp',
	templateUrl: 'navbar.component.html'
})
export class NavbarComponent implements OnInit, OnDestroy {
	private listTitles: any[];
	location: Location;
	private nativeElement: Node;
	private toggleButton;
	private sidebarVisible: boolean;
	env: string;
	nameOfUser: string;

	userSubscription: Subscription;

	@ViewChild('navbar-cmp') button;

	constructor(
		location: Location,
		private renderer: Renderer,
		private element: ElementRef,
		public authService: AuthService,
		public userIdleService: UserIdleService,
		private router: Router,
		private userInfoService: UserInfoService
	) {
		this.location = location;
		this.nativeElement = element.nativeElement;
		this.sidebarVisible = false;
	}

	ngOnInit() {
		this.env = environment.name;
		this.listTitles = ROUTES.filter((listTitle) => listTitle);
		var navbar: HTMLElement = this.element.nativeElement;
		this.toggleButton = navbar.getElementsByClassName('navbar-toggle')[0];

		this.userSubscription = this.userInfoService
			.getByValue('', this.authService.currentUser.username)
			.subscribe((res) => {
				if (res[0]) {
					this.nameOfUser = res[0].name + ' ' + res[0].lastname;
				}
			});
	}

	ngOnDestroy(): void {
		this.userSubscription.unsubscribe();
	}

	getTitle() {
		var title = window.location.pathname;
		for (var item = 0; item < this.listTitles.length; item++) {
			if (title.includes(this.listTitles[item].path)) {
				return this.listTitles[item].title;
			}
		}
		return 'DMS Control';
	}
	isMobile() {
		if ($(window).width() > 991) {
			return false;
		}
		return true;
	}
	sidebarToggle() {
		var toggleButton = this.toggleButton;
		var body = document.getElementsByTagName('body')[0];

		if (this.sidebarVisible == false) {
			setTimeout(function () {
				toggleButton.classList.add('toggled');
			}, 500);
			body.classList.add('nav-open');
			this.sidebarVisible = true;
		} else {
			this.toggleButton.classList.remove('toggled');
			this.sidebarVisible = false;
			body.classList.remove('nav-open');
		}
	}

	viewUserProfile() {
		this.router.navigate(['/profile']);
	}

	logout() {
		this.authService.logout();
		this.router.navigate(['/login']);
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/shared/navbar/navbar.component.ts